module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_vm._v("AUTHOR’S PREFACE.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In laying this book before the Public I desire, in the first\ninstance, to acknowledge without reserve my sense of the\ngreat merits of my colleague, Lieutenant Weyprecht. The\nreader of the following pages will learn with what unwearied,\nthough fruitless, energy he struggled to free the "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Tegetthoff")]), _vm._v("\nfrom her icy prison, and what dauntless courage and unfailing\ncommand of resources he displayed in our hazardous retreat\nfrom the abandoned ship, till the moment of our happy rescue.\nThe order and discipline maintained on board ship, and in the\nterrible march over the Frozen Ocean, as well as in the perilous\nboat voyage after leaving the ice-barrier, were mainly due\nto his distinguished abilities. He had supreme command of\nthe expedition, as long as its duties were strictly nautical;\nwhen the operations of sledging and surveying began, I had\nthe responsibility of a separate and independent command.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nor ought I to be slow to pay my tribute of respect to the\nperseverance and constant self-denial of Lieutenant Brosch\nand Midshipman Orel. It would be difficult to determine,\nwhether they shone more as officers of the ship, or as\nobservers of scientific phenomena. The highly important\nduty of managing the stores and provisions was discharged\nalso by Lieutenant Brosch with a conscientiousness that\nsecured the confidence of all.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("To the watchful skill of Dr. Kepes we owed it, that the\nhealth and constitution of the members of the expedition\nsuffered so little from all their hardships and privations.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00007",
      "title": "[vi]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_vi",
      "title": "[vi]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The conduct of the crew was on the whole praiseworthy.\nTheir obedience to command, their perseverance and resolution\nshown on every occasion, will be cited as an example of\nwhat these virtues and qualities can achieve amid the most\nappalling dangers and trials.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("With regard to my narrative, I make no claim for it founded\non its literary excellence; rather I sue for indulgence to its\nmanifold shortcomings. I have not written for the man of\nscience, though I have not shunned a few scientific details.\nNor have I aimed at presenting a record, which might be profitable\nto those who shall follow us in the same career of\ndiscovery, though some hints will be found in my pages which\nwill not be without their use to those who may consult them\nfor information and guidance. Rather I have endeavoured to\nnarrate our sufferings, adventures, and discoveries in a manner\nwhich shall be interesting to the general reader who reads to\namuse himself.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The magnetical and meteorological observations, so carefully\ntaken and tabulated by Weyprecht, Brosch, and Orel,\ntogether with the sketches of the Fauna of the Frozen Ocean,\ndrawn by myself from the collection of Dr. Kepes, were\npresented to the Imperial Academy of Sciences of Vienna,\nand will in due time be published under the auspices of\nthat august body.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00008",
      "title": "[vii]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_vii",
      "title": "[vii]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0